const ar = {
  // Navigation
  'nav.home': 'الرئيسية',
  'nav.about': 'من نحن',
  'nav.services': 'خدماتنا',
  'nav.revenueSharing': 'تقاسم الأرباح',
  'nav.partnership': 'الشراكة',
  'nav.joinUs': 'انضم إلينا',
  'nav.contact': 'تواصل معنا',
  'nav.getStarted': 'ابدأ الآن',
  'nav.switchLang': 'English',

  // WhatsApp
  'wa.tooltip': 'تحدث معنا عبر واتساب',

  // Footer
  'footer.brandDesc': 'نبني المستقبل، سطراً برمجياً في كل مرة. حلول تقنية احترافية للمؤسسات التي ترفض الاستقرار على أقل من الأفضل.',
  'footer.servicesTitle': 'الخدمات',
  'footer.companyTitle': 'الشركة',
  'footer.contactTitle': 'التواصل',
  'footer.emailLabel': 'راسلنا',
  'footer.phoneLabel': 'اتصل بنا',
  'footer.availLabel': 'التوفر',
  'footer.availValue': 'خدمات عالمية',
  'footer.copyright': '© {{year}} الكود المميز. جميع الحقوق محفوظة.',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'شروط الخدمة',
  'footer.srv1': 'الهوية والتصميم',
  'footer.srv2': 'تطوير المواقع',
  'footer.srv3': 'تطبيقات الجوال',
  'footer.srv4': 'الذكاء الاصطناعي',
  'footer.srv5': 'التسويق الرقمي',
  'footer.srv6': 'استشارات تقنية',
  'footer.lnk1': 'من نحن',
  'footer.lnk2': 'فريقنا',
  'footer.lnk3': 'انضم إلينا',
  'footer.lnk4': 'تقاسم الأرباح',
  'footer.lnk5': 'تواصل معنا',
  'footer.lnk6': 'الشراكة',

  // Hero
  'hero.badge': 'موثوق من أكثر من 500 عميل حول العالم',
  'hero.title1': 'حوّل رؤيتك',
  'hero.title2': 'الرقمية',
  'hero.title3': 'إلى واقع',
  'hero.desc': 'نصنع حلولاً تقنية متطورة — من تطبيقات الويب والجوال إلى أنظمة الذكاء الاصطناعي — تحقق نمواً ملموساً لعملك.',
  'hero.cta1': 'ابدأ مشروعك',
  'hero.cta2': 'استكشف الخدمات',
  'hero.statClients': 'عميل',
  'hero.statProjects': 'مشروع',
  'hero.statCountries': 'دولة',
  'hero.statYears': 'سنوات',

  // Stats
  'stats.label': 'أرقامنا تتحدث',
  'stats.title': 'سجل حافل بالنجاحات',
  'stats.clientsLabel': 'عميل سعيد',
  'stats.clientsDesc': 'حول العالم',
  'stats.projectsLabel': 'مشروع مُنجز',
  'stats.projectsDesc': 'في الوقت والميزانية',
  'stats.yearsLabel': 'سنوات من التميز',
  'stats.yearsDesc': 'خبرة في المجال',
  'stats.countriesLabel': 'دولة نخدمها',
  'stats.countriesDesc': 'حضور عالمي',

  // Why Choose Us
  'whyUs.label': 'لماذا تعمل معنا',
  'whyUs.title': 'ما الذي يميزنا؟',
  'whyUs.desc': 'نجمع بين التميز التقني والتفكير الاستراتيجي لتقديم حلول تُحدث فرقاً حقيقياً في نتائج عملك.',
  'whyUs.item1Title': 'الابتكار أولاً',
  'whyUs.item1Desc': 'نتجاوز الحدود بالتقنيات الحديثة. يستكشف فريقنا باستمرار أدوات وأطر عمل جديدة لتقديم حلول مستقبلية.',
  'whyUs.item2Title': 'أعلى مستويات الأداء',
  'whyUs.item2Desc': 'كل منتج نبنيه مُحسَّن للسرعة وقابلية التوسع والموثوقية. الأداء ليس فكرة لاحقة — بل هو أساس عملنا.',
  'whyUs.item3Title': 'العميل في المقدمة',
  'whyUs.item3Desc': 'نجاحك هو مهمتنا. نحافظ على تواصل شفاف، نلتزم بالمواعيد، ونقدم دعماً مستمراً بعد كل إطلاق مشروع.',
  'whyUs.item4Title': 'خبرة عالمية',
  'whyUs.item4Desc': 'مع مشاريع في أكثر من 50 دولة، نفهم الأسواق المتنوعة ونجلب أفضل الممارسات الدولية لكل تعاون.',
  'whyUs.item5Title': 'آمن وموثوق',
  'whyUs.item5Desc': 'نطبق معايير أمان المستوى المؤسسي في كل منتج نبنيه، لضمان حماية بياناتك وبيانات عملائك دائماً.',
  'whyUs.item6Title': 'مرن وسريع التكيف',
  'whyUs.item6Desc': 'نتكيف مع طريقة عملك. سواء كان مشروعاً ناشئاً أو برمجيات مؤسسية، نُكيّف عمليتنا حسب احتياجاتك وجدولك.',

  // Why Choose Unique Code
  'whyUC.label': 'ميزتنا التنافسية',
  'whyUC.title1': 'لماذا تختار',
  'whyUC.title2': 'الكود المميز؟',
  'whyUC.desc': 'نحن لسنا مجرد شركة برمجيات — نحن شريكك التقني طويل الأمد. من الفكرة حتى الإطلاق وما بعده، نسير معك في كل خطوة.',
  'whyUC.f1Title': 'آمن وموثوق',
  'whyUC.f1Desc': 'معايير أمان مؤسسية في كل منتج نُطلقه.',
  'whyUC.f2Title': 'دعم على مدار الساعة',
  'whyUC.f2Desc': 'فريقنا دائماً متاح للمساعدة — في أي وقت.',
  'whyUC.f3Title': 'تسليم في الوقت المحدد',
  'whyUC.f3Desc': 'نحترم المواعيد. كل مرحلة تُسلَّم في وقتها دائماً.',
  'whyUC.f4Title': 'حضور عالمي',
  'whyUC.f4Desc': 'نخدم عملاء في أكثر من 50 دولة بخبرة محلية.',
  'whyUC.f5Title': 'فريق من الخبراء',
  'whyUC.f5Desc': 'أكثر من 30 متخصصاً في التصميم والهندسة والذكاء الاصطناعي والتسويق.',
  'whyUC.f6Title': 'عمل حائز على جوائز',
  'whyUC.f6Desc': 'معترف بنا للتميز في تصميم المنتجات الرقمية.',
  'whyUC.satisfactionLabel': 'رضا العملاء',
  'whyUC.ratingLabel': 'متوسط التقييم',

  // Core Services (Home)
  'svc.label': 'ما نقدمه',
  'svc.title': 'خدماتنا الأساسية',
  'svc.viewAll': 'عرض جميع الخدمات',
  'svc.learnMore': 'اعرف أكثر',
  'svc.item1Title': 'الهوية والتصميم',
  'svc.item1Desc': 'نصنع هويات بصرية قوية تجعل علامتك التجارية لا تُنسى. من الشعارات إلى أنظمة العلامة التجارية الكاملة.',
  'svc.item1Tag': 'إبداعي',
  'svc.item2Title': 'تطوير المواقع',
  'svc.item2Desc': 'نبني مواقع سريعة ومتجاوبة ومُحسَّنة للتحويل بأحدث التقنيات. حضورك الرقمي مُهندَس للنتائج.',
  'svc.item2Tag': 'هندسي',
  'svc.item3Title': 'تطبيقات الجوال',
  'svc.item3Desc': 'تطبيقات iOS وAndroid الأصلية التي يحبها المستخدمون. نصمم ونطور حلول جوال عالية الأداء.',
  'svc.item3Tag': 'جوال',
  'svc.item4Title': 'الذكاء الاصطناعي',
  'svc.item4Desc': 'استغل قوة الذكاء الاصطناعي والتعلم الآلي وإنترنت الأشياء لأتمتة العمليات واكتساب ميزة تنافسية.',
  'svc.item4Tag': 'ذكاء اصطناعي',
  'svc.item5Title': 'التسويق الرقمي',
  'svc.item5Desc': 'استراتيجيات تسويق مبنية على البيانات تولّد عملاء محتملين وتنمي جمهورك وتعظم العائد على الاستثمار.',
  'svc.item5Tag': 'نمو',
  'svc.item6Title': 'استشارات تقنية',
  'svc.item6Desc': 'استشارات تقنية استراتيجية لمواءمة بنيتك التحتية مع أهداف عملك. نراجع ونخطط وننفذ بدقة.',
  'svc.item6Tag': 'استشاري',

  // Testimonials
  'tst.label': 'آراء العملاء',
  'tst.title': 'ماذا يقول عملاؤنا',
  'tst.desc': 'لا تكتفِ بكلامنا — استمع مباشرة من الأعمال التي ساعدناها على النمو.',
  'tst.item1Name': 'أحمد الراشد',
  'tst.item1Role': 'الرئيس التنفيذي، تيك بريدج العربية',
  'tst.item1Text': 'أنجز الكود المميز منصتنا للتجارة الإلكترونية قبل الموعد المحدد وتجاوزت كل التوقعات. الاهتمام بالتفاصيل وجودة الكود لا مثيل لهما.',
  'tst.item2Name': 'سارة ميتشل',
  'tst.item2Role': 'مديرة المنتج، نوفاسوفت',
  'tst.item2Text': 'التطبيق الذي بنوه لنا حصل على تقييم 4.9 نجمة في متجر التطبيقات. فريق UI/UX يفهم فعلاً سلوك المستخدم ويحوله إلى تصميم جميل وفعّال.',
  'tst.item3Name': 'خالد المنصوري',
  'tst.item3Role': 'المؤسس، فينتك الخليج',
  'tst.item3Text': 'نظام تحليل المخاطر بالذكاء الاصطناعي الذي بناه الكود المميز قلّص وقت المعالجة اليدوية بنسبة 80٪. تحويل حقيقي لعملياتنا.',

  // CTA
  'cta.badge': 'جاهز للإطلاق؟',
  'cta.title1': 'دعنا نبني شيئاً',
  'cta.title2': 'استثنائياً',
  'cta.desc': 'سواء كنت شركة ناشئة بفكرة جريئة أو مؤسسة تسعى للابتكار — لدينا الخبرة لتحويل رؤيتك إلى منتج رقمي عالمي المستوى.',
  'cta.btn1': 'تواصل معنا',
  'cta.btn2': 'انضم لفريقنا',
  'cta.trust1': 'أمان مؤسسي',
  'cta.trust2': 'تسليم في الوقت',
  'cta.trust3': 'دعم على مدار الساعة',
  'cta.trust4': 'حائزون على جوائز',

  // About Page
  'about.heroLabel': 'من نحن',
  'about.heroTitle1': 'الفريق الذي يقف وراء',
  'about.heroTitle2': 'نجاحك الرقمي',
  'about.heroDesc': 'الكود المميز شركة تقنية عالمية تبني تجارب رقمية تحوّل الأعمال. من الشركات الناشئة إلى المؤسسات الكبرى — نجعل التكنولوجيا تعمل لصالحك.',
  'about.purposeLabel': 'غايتنا',
  'about.purposeTitle': 'رسالتنا ورؤيتنا',
  'about.missionTitle': 'رسالتنا',
  'about.missionDesc': 'تمكين الأعمال حول العالم بحلول تقنية متطورة تحقق نمواً قابلاً للقياس وكفاءة تشغيلية وميزة تنافسية دائمة.',
  'about.visionTitle': 'رؤيتنا',
  'about.visionDesc': 'أن نكون الشريك التقني الأكثر ثقة للأعمال حول العالم، المشهود له بالابتكار والجودة والأثر التحويلي في كل مشروع.',
  'about.promiseTitle': 'وعدنا',
  'about.promiseDesc': 'كل مشروع نتولاه يحظى بالتزامنا الكامل — من الاستراتيجية حتى الإطلاق وما بعده. نحن لسنا مجرد موردين، بل شركاء تقنيون طويلو الأمد.',
  'about.yearsCard': '+9',
  'about.yearsLabel': 'سنوات من التميز',
  'about.satisfactionCard': '98%',
  'about.satisfactionLabel': 'رضا العملاء',
  'about.valuesLabel': 'ما يحركنا',
  'about.valuesTitle': 'قيمنا الأساسية',
  'about.val1Title': 'الابتكار أولاً',
  'about.val1Desc': 'نتجاوز باستمرار حدود التكنولوجيا لتقديم حلول مستقبلية النظرة.',
  'about.val2Title': 'النزاهة دائماً',
  'about.val2Desc': 'الصدق والشفافية هما أساس كل علاقة عميل نبنيها.',
  'about.val3Title': 'التميز في كل شيء',
  'about.val3Desc': 'لا نقبل بأقل من نتائج استثنائية في كل ما نقوم به.',
  'about.val4Title': 'العميل في المركز',
  'about.val4Desc': 'نجاحك هو مقياسنا. نصمم حلولاً حول تحدياتك الفريدة.',
  'about.val5Title': 'التفكير العالمي',
  'about.val5Desc': 'مع عملاء في أكثر من 50 دولة، نجلب منظوراً عالمياً لكل مشروع.',
  'about.val6Title': 'النمو المستدام',
  'about.val6Desc': 'نبني حلولاً تتوسع مع عملك لسنوات قادمة.',
  'about.timelineLabel': 'قصتنا',
  'about.timelineTitle': 'رحلة الكود المميز',
  'about.ms1Year': '2017',
  'about.ms1Title': 'التأسيس',
  'about.ms1Desc': 'تأسس الكود المميز عام 2017 بمهمة إتاحة التقنية المتميزة لجميع الأعمال.',
  'about.ms2Year': '2020',
  'about.ms2Title': '100 عميل',
  'about.ms2Desc': 'وصلنا لأول 100 عميل رغم التحديات العالمية، مما أثبت الطلب على التقنية الجيدة.',
  'about.ms3Year': '2021',
  'about.ms3Title': 'التوسع العالمي',
  'about.ms3Desc': 'توسعنا لخدمة العملاء في الشرق الأوسط وأوروبا وأمريكا الشمالية.',
  'about.ms4Year': '2022',
  'about.ms4Title': 'إطلاق قسم الذكاء الاصطناعي',
  'about.ms4Desc': 'أطلقنا قسم الذكاء الاصطناعي والتقنيات الذكية المخصص لقيادة موجة الابتكار التالية.',
  'about.ms5Year': '2023',
  'about.ms5Title': '+500 مشروع',
  'about.ms5Desc': 'أنجزنا أكثر من 500 مشروع ناجح ونمونا لفريق يضم أكثر من 80 متخصصاً.',
  'about.ms6Year': '2024',
  'about.ms6Title': '+50 دولة',
  'about.ms6Desc': 'نخدم الآن عملاء في أكثر من 50 دولة مع نموذج تقاسم الأرباح المُحدِث في المجال.',
  'about.teamLabel': 'الخبراء',
  'about.teamTitle': 'تعرف على قيادتنا',
  'about.teamDesc': 'رواد وصانعو إبداع ومهندسون يجمعهم شغف ببناء تجارب رقمية استثنائية.',
  'about.t1Name': 'أحمد الراشد',
  'about.t1Role': 'الرئيس التنفيذي والمؤسس',
  'about.t1Bio': 'قائد رؤيوي بخبرة 12+ سنة في التقنية. بنى الكود المميز لإعادة تعريف التحول الرقمي للأعمال عالمياً.',
  'about.t2Name': 'سارة المنصوري',
  'about.t2Role': 'مديرة التصميم التنفيذية',
  'about.t2Bio': 'مصممة حائزة على جوائز شكّلت هوية أكثر من 200 شركة في أكثر من 30 دولة.',
  'about.t3Name': 'عمر خالد',
  'about.t3Role': 'المدير التقني',
  'about.t3Bio': 'مهندس معماري full-stack ومتحمس للذكاء الاصطناعي بسجل حافل في تسليم المنصات المؤسسية القابلة للتوسع.',
  'about.t4Name': 'فاطمة حسن',
  'about.t4Role': 'رئيسة الذكاء الاصطناعي والابتكار',
  'about.t4Bio': 'خبيرة تعلم آلي تجلب حلول الذكاء الاصطناعي المتطورة لتحديات الأعمال بأثر عملي ملموس.',
  'about.ctaTitle': 'هل أنت مستعد لبناء شيء رائع؟',
  'about.ctaDesc': 'انضم لأكثر من 500 شركة تثق بالكود المميز لقيادة نموها الرقمي.',
  'about.ctaBtn1': 'تواصل معنا',
  'about.ctaBtn2': 'انضم لفريقنا',

  // Services Page
  'srvPage.heroLabel': 'ما نقدمه',
  'srvPage.heroTitle1': 'خدمات تقنية',
  'srvPage.heroTitle2': 'متكاملة من البداية للنهاية',
  'srvPage.heroDesc': 'من الهوية البصرية إلى الذكاء الاصطناعي — نغطي كل أبعاد احتياجاتك الرقمية بدقة وإبداع ونتائج قابلة للقياس.',
  'srvPage.selectLabel': 'اختر الخدمة',
  'srvPage.getQuote': 'احصل على عرض',
  'srvPage.whatsIncluded': 'ما يتضمنه',
  'srvPage.overviewLabel': 'كل ما نقدمه',
  'srvPage.overviewTitle': 'مجموعة خدماتنا الكاملة',
  'srvPage.processLabel': 'كيف نعمل',
  'srvPage.processTitle': 'منهجيتنا المُثبتة',
  'srvPage.ctaTitle': 'دعنا نبدأ البناء',
  'srvPage.ctaDesc': 'أخبرنا بفكرتك وسنحولها إلى شيء رائع. لا التزام مطلوب في الاستشارة الأولى.',
  'srvPage.ctaBtn': 'اطلب استشارة مجانية',
  'srvPage.process1Title': 'الاكتشاف',
  'srvPage.process1Desc': 'نبدأ بفهم عميق لعملك وأهدافك وتحدياتك من خلال جلسات اكتشاف منظمة.',
  'srvPage.process2Title': 'الاستراتيجية',
  'srvPage.process2Desc': 'يضع فريقنا خارطة طريق مخصصة بمراحل واضحة وتقنيات ونتائج متوقعة.',
  'srvPage.process3Title': 'البناء',
  'srvPage.process3Desc': 'ننفذ بدقة — دورات تكرارية وعروض منتظمة وشفافية كاملة طوال التطوير.',
  'srvPage.process4Title': 'الإطلاق والتوسع',
  'srvPage.process4Desc': 'ننشر ونراقب ونحسّن وندعم منتجك لفترة طويلة بعد الإطلاق لنمو مستمر.',

  // Contact Page
  'contact.heroLabel': 'تواصل معنا',
  'contact.heroTitle1': 'لنبدأ',
  'contact.heroTitle2': 'محادثة',
  'contact.heroDesc': 'هل لديك مشروع في ذهنك؟ سؤال عن خدماتنا؟ أو تريد استكشاف ما يمكننا فعله معاً؟ تواصل — نرد خلال 24 ساعة.',
  'contact.infoLabel': 'بيانات التواصل',
  'contact.infoTitle': 'يسعدنا سماعك',
  'contact.infoDesc': 'سواء كنت شركة ناشئة بفكرة كبيرة أو مؤسسة تسعى للتحديث أو فرداً يستكشف فرص الشراكة — فريقنا هنا لمساعدتك.',
  'contact.followTitle': 'تابعنا',
  'contact.formTitle': 'أرسل لنا رسالة',
  'contact.nameLabel': 'الاسم الكامل',
  'contact.namePlaceholder': 'اسمك',
  'contact.emailLabel2': 'البريد الإلكتروني',
  'contact.emailPlaceholder': 'بريدك@المثال.com',
  'contact.phoneLabel2': 'رقم الجوال',
  'contact.phonePlaceholder': '+966 5XXXXXXXX',
  'contact.companyLabel': 'اسم الشركة',
  'contact.companyPlaceholder': 'شركتك (اختياري)',
  'contact.serviceLabel': 'الخدمة التي تهمك',
  'contact.serviceDefault': 'اختر خدمة',
  'contact.budgetLabel': 'ميزانية المشروع',
  'contact.budgetDefault': 'اختر نطاق الميزانية',
  'contact.messageLabel': 'أخبرنا عن مشروعك',
  'contact.messagePlaceholder': 'صف مشروعك وأهدافك وأي متطلبات زمنية...',
  'contact.submitBtn': 'إرسال الرسالة',
  'contact.sendingText': 'جاري الإرسال...',
  'contact.successTitle': 'تم إرسال الرسالة!',
  'contact.successDesc': 'شكراً للتواصل! سيرد أحد أعضاء فريقنا خلال 24 ساعة.',
  'contact.successBtn': 'إرسال رسالة أخرى',
  'contact.errorText': 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  'contact.locationValue': 'الرياض، المملكة العربية السعودية',
  'contact.hoursValue': 'الأحد – الخميس: 9 صباحاً – 6 مساءً',

  // Join Page
  'join.heroLabel': 'الوظائف',
  'join.heroTitle1': 'ابنِ المستقبل',
  'join.heroTitle2': 'معنا',
  'join.heroDesc': 'انضم لفريق من البنّائين والمصممين والمبتكرين الشغوفين الذين يصنعون منتجات رقمية تؤثر في ملايين الأشخاص حول العالم.',
  'join.heroBadge': 'نحن نوظف — {{count}} وظيفة شاغرة',
  'join.perksLabel': 'لماذا تنضم إلينا',
  'join.perksTitle': 'الحياة في الكود المميز',
  'join.openingsLabel': 'الوظائف المتاحة',
  'join.openingsTitle': 'الوظائف الشاغرة',
  'join.applyLabel': 'تقدم الآن',
  'join.applyTitle': 'أرسل طلبك',
  'join.applySelected': 'تقدم لوظيفة: {{role}}',
  'join.applyDefault': 'اختر وظيفة من الأعلى أو تقدم بطلب عام',
  'join.nameLabel': 'الاسم الكامل',
  'join.emailLabel': 'البريد الإلكتروني',
  'join.phoneLabel': 'رقم الجوال',
  'join.expLabel': 'سنوات الخبرة',
  'join.roleLabel': 'الوظيفة المطلوبة',
  'join.portfolioLabel': 'رابط المحفظة / لينكدإن',
  'join.cvLabel': 'رابط السيرة الذاتية',
  'join.cvPlaceholder': 'Google Drive أو Dropbox أو أي رابط مشترك...',
  'join.cvNote': 'شارك رابطاً للسيرة الذاتية (Google Drive أو Dropbox أو OneDrive)',
  'join.aboutLabel': 'أخبرنا عن نفسك',
  'join.submitBtn': 'إرسال الطلب',
  'join.submittingText': 'جاري الإرسال...',
  'join.successTitle': 'تم استلام طلبك!',
  'join.successDesc': 'نراجع الطلبات شخصياً. توقع أن تسمع منا خلال 3-5 أيام عمل.',
  'join.successBtn': 'إرسال طلب آخر',
  'join.errorText': 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  'join.selectPosition': 'اختر وظيفة',
  'join.generalApp': 'طلب عام',
  'join.fulltime': 'دوام كامل',
  'join.hybrid': 'هجين',
  'join.remote': 'عن بعد',
  // Job openings
  'join.o1role': 'مطور واجهة أمامية أول',
  'join.o1team': 'الهندسة',
  'join.o1desc': 'بناء تجارب ويب استثنائية باستخدام React وTypeScript وأدوات الواجهة الأمامية الحديثة.',
  'join.o2role': 'مصمم UI/UX',
  'join.o2team': 'التصميم',
  'join.o2desc': 'تصميم واجهات محورها المستخدم لمنتجات الويب والجوال في مشاريع عملاء متنوعة.',
  'join.o3role': 'مطور تطبيقات جوال',
  'join.o3team': 'الهندسة',
  'join.o3desc': 'تطوير تطبيقات iOS وAndroid عالية الجودة باستخدام React Native والتقنيات الأصلية.',
  'join.o4role': 'مهندس ذكاء اصطناعي / تعلم آلي',
  'join.o4team': 'قسم الذكاء الاصطناعي',
  'join.o4desc': 'بناء أنظمة ذكية ونماذج تعلم آلي تحل مشكلات الأعمال الفعلية.',
  'join.o5role': 'متخصص تسويق رقمي',
  'join.o5team': 'التسويق',
  'join.o5desc': 'إدارة حملات مبنية على البيانات عبر القنوات المدفوعة والعضوية والاجتماعية لأكثر من 30 عميلاً.',
  'join.o6role': 'مسؤول مبيعات',
  'join.o6team': 'تطوير الأعمال',
  'join.o6desc': 'قيادة أعمال جديدة في دول مجلس التعاون الخليجي والأسواق الدولية بمحفظتنا التقنية المتميزة.',
  // Perks
  'join.p1title': 'العمل عن بعد',
  'join.p1desc': 'اعمل من أي مكان في العالم. نحن نثق في إنجازك.',
  'join.p2title': 'راتب تنافسي',
  'join.p2desc': 'رواتب رائدة في السوق بالإضافة إلى مكافآت الأداء.',
  'join.p3title': 'ميزانية التعلم',
  'join.p3desc': 'ميزانية سنوية للدورات والشهادات والمؤتمرات.',
  'join.p4title': 'التغطية الصحية',
  'join.p4desc': 'تغطية طبية وصحية كاملة لك ولعائلتك.',
  'join.p5title': 'ساعات مرنة',
  'join.p5desc': 'ثقافة موجّهة بالنتائج. امتلك جدولك الزمني.',
  'join.p6title': 'مسار النمو',
  'join.p6desc': 'مسارات مهنية واضحة مع فرص قيادية في كل مستوى.',

  // Revenue Sharing
  'rev.heroLabel': 'نموذج الشراكة',
  'rev.heroTitle1': 'ننمو',
  'rev.heroTitle2': 'معاً',
  'rev.heroBadge': 'نموذج شراكتنا الفريد',
  'rev.heroSubtitle': 'تدفع فقط عندما تحقق أرباحاً.',
  'rev.heroDesc': 'نموذج تقاسم الأرباح في الكود المميز يعني أننا نستثمر في تسويقك إلى جانبك. إذا لم تنمُ، لم نكسب. إنها أكثر شراكة متوافقة في المجال.',
  'rev.exploreBtn': 'استكشف الشراكة',
  'rev.modelLabel': 'شرح النموذج',
  'rev.modelTitle': 'ما هو تقاسم الأرباح؟',
  'rev.modelDesc1': 'تقاسم الأرباح هو نموذج شراكة مبني على الأداء يستثمر فيه الكود المميز خبرته وفريقه وموارده في تنمية عملك — وفي المقابل يحصل على نسبة محددة مسبقاً من الإيرادات الجديدة التي نولّدها.',
  'rev.modelDesc2': 'بخلاف الوكالات التقليدية التي تفرض رسوماً شهرية ثابتة بصرف النظر عن النتائج، نموذجنا يعني أن كل عضو في فريقنا محفّز شخصياً لتقديم نتائج استثنائية. فوزك هو فوزنا.',
  'rev.stat1Label': 'عميل على هذا النموذج',
  'rev.stat1Value': '+120',
  'rev.stat2Label': 'متوسط نمو الإيرادات',
  'rev.stat2Value': '3.8x',
  'rev.stat3Label': 'قطاعات نخدمها',
  'rev.stat3Value': '+15',
  'rev.stat4Label': 'معدل الرضا',
  'rev.stat4Value': '97%',
  'rev.processLabel': 'العملية',
  'rev.processTitle': 'كيف يعمل',
  'rev.step1Title': 'الاستشارة الأولية',
  'rev.step1Desc': 'نجتمع لفهم نموذج عملك وأهداف النمو واحتياجاتك التسويقية.',
  'rev.step2Title': 'اتفاقية مخصصة',
  'rev.step2Desc': 'نصيغ اتفاقية تقاسم أرباح شفافة مصممة لعملك ومستوى المخاطر المقبول لديك.',
  'rev.step3Title': 'التنفيذ والاستثمار',
  'rev.step3Desc': 'يطلق فريقنا حملات تسويقية شاملة — نتحمل التكلفة المسبقة، وأنت تراقب تدفق العملاء.',
  'rev.step4Title': 'توزيع الأرباح',
  'rev.step4Desc': 'مع نمو الإيرادات، نحصل على نسبتنا المتفق عليها. لا نتائج = لا دفع كامل. بسيطة بهذا القدر.',
  'rev.benefitsLabel': 'لماذا ينجح هذا',
  'rev.benefitsTitle': 'فوائد الشراكة معنا',
  'rev.ben1Title': 'لا مخاطرة مسبقة',
  'rev.ben1Desc': 'لا تدفع رسوماً ضخمة. نستثمر في نموك ونكسب عندما تكسب.',
  'rev.ben2Title': 'حوافز متوافقة',
  'rev.ben2Desc': 'فريقنا محفّز 100٪ لتقديم نتائج لأننا نشارك في نجاحك.',
  'rev.ben3Title': 'خبرة مُثبتة',
  'rev.ben3Desc': 'طبّقنا هذا النموذج في أكثر من 50 شركة في 15+ قطاعاً بنتائج ثابتة.',
  'rev.ben4Title': 'نماذج مرنة',
  'rev.ben4Desc': 'نكيّف نسبة تقاسم الأرباح والشروط وفق مرحلة عملك وأهدافك.',
  'rev.ben5Title': 'فريق متكامل',
  'rev.ben5Desc': 'تحصل على فريق مخصص من المسوقين والمصممين والمحللين يعملون على نموك.',
  'rev.ben6Title': 'نمو قابل للتوسع',
  'rev.ben6Desc': 'مع توسع عملك، تتوسع طاقتنا معك. لا قيود على البائع، فقط نمو.',
  'rev.faqLabel': 'أسئلة شائعة',
  'rev.faqTitle': 'الأسئلة المتكررة',
  'rev.faq1Q': 'ما نسبة الإيرادات التي يأخذها الكود المميز؟',
  'rev.faq1A': 'يتفاوت حسب الصناعة وحجم الحملة، لكنه عادةً يتراوح بين 15٪ و30٪ من الإيرادات الجديدة. يُتفاوض عليه بشفافية مسبقاً.',
  'rev.faq2Q': 'هل هناك أي تكلفة مسبقة؟',
  'rev.faq2A': 'نطلب رسوم تهيئة بسيطة تغطي الإعداد والاستراتيجية — أقل بكثير من رسوم الوكالات التقليدية. بعدها يصبح كل شيء مبنياً على الأداء.',
  'rev.faq3Q': 'ما الحد الأدنى لمدة العقد؟',
  'rev.faq3A': 'نوصي بالتزام 6 أشهر على الأقل لرؤية نتائج ملموسة. معظم العملاء يستمرون طويلاً بعد مشاهدة النمو المتضاعف.',
  'rev.faq4Q': 'لأي صناعات يناسب هذا النموذج؟',
  'rev.faq4A': 'طبّقنا هذا النموذج بنجاح في التجارة الإلكترونية والعقارات والـSaaS والرعاية الصحية والتعليم والضيافة وغيرها. احجز مكالمة لتقييم ملاءمة صناعتك.',
  'rev.faq5Q': 'كيف يتم تتبع الإيرادات والتحقق منها؟',
  'rev.faq5A': 'نتكامل مباشرة مع نظام CRM وأدوات التحليل وأنظمة الدفع لضمان تتبع شفاف وقابل للتدقيق لكل عميل محتمل وتحويل نولّده.',
  'rev.faq6Q': 'هل يمكنني التحول لنموذج ثابت لاحقاً؟',
  'rev.faq6A': 'بالتأكيد. كثير من العملاء يبدأون بتقاسم الأرباح ثم ينتقلون لنموذج هجين أو ثابت بعد بناء الثقة ونمو الميزانيات.',
  'rev.ctaTitle': 'مستعد للنمو معاً؟',
  'rev.ctaDesc': 'احجز مكالمة استراتيجية مجانية ودعنا نستكشف إذا كان نموذج تقاسم الأرباح مناسباً لعملك.',
  'rev.ctaBtn': 'تقدم بطلب شراكة',

  // Services Page - Long Descriptions & Features
  'srvPage.branding.longDesc': 'علامتك التجارية هي الانطباع الأول الذي تتركه — ونحن نضمن أن يدوم. يعمل فريق التصميم لدينا معك لبناء هويات متماسكة وذات معنى تبرز في الأسواق المزدحمة.',
  'srvPage.branding.f1': 'تصميم الشعار والهوية البصرية',
  'srvPage.branding.f2': 'تصميم UI/UX للويب والجوال',
  'srvPage.branding.f3': 'دليل العلامة التجارية وأدلة الأسلوب',
  'srvPage.branding.f4': 'المواد التسويقية والمطبوعات',
  'srvPage.branding.f5': 'الرسوم المتحركة والموشن جرافيك',
  'srvPage.branding.f6': 'مجموعات المرئيات لوسائل التواصل الاجتماعي',

  'srvPage.web.longDesc': 'نبني تجارب ويب تجمع بين التصميم الرائع والهندسة المتينة. سواء كنت تحتاج موقعاً تسويقياً أو منصة SaaS معقدة أو محرك تجارة إلكترونية — نحن نُنجز.',
  'srvPage.web.f1': 'تطوير مواقع مخصصة',
  'srvPage.web.f2': 'التجارة الإلكترونية والمتاجر الإلكترونية',
  'srvPage.web.f3': 'تطبيقات SaaS وتطبيقات الويب',
  'srvPage.web.f4': 'تكامل نظام إدارة المحتوى',
  'srvPage.web.f5': 'تحسين الأداء وتهيئة محركات البحث',
  'srvPage.web.f6': 'تطوير وتكامل واجهات برمجة التطبيقات',

  'srvPage.mobile.longDesc': 'الجوال هو المكان الذي يعيش فيه عملاؤك. نصمم ونطور تطبيقات جوال عالية الأداء تحقق قيمة تجارية حقيقية — من تطبيقات المستهلكين إلى أدوات المؤسسات.',
  'srvPage.mobile.f1': 'تطوير iOS (Swift)',
  'srvPage.mobile.f2': 'تطوير Android (Kotlin)',
  'srvPage.mobile.f3': 'تطوير متعدد المنصات (React Native)',
  'srvPage.mobile.f4': 'تحسين متجر التطبيقات',
  'srvPage.mobile.f5': 'الإشعارات الفورية والتحليلات',
  'srvPage.mobile.f6': 'الصيانة وتحديثات الإصدارات',

  'srvPage.ai.longDesc': 'المستقبل ذكي — ونحن نساعدك على الوصول إليه. يبني قسم الذكاء الاصطناعي لدينا نماذج تعلم آلي مخصصة وأنظمة أتمتة ذكية وأدوات مبنية على البيانات.',
  'srvPage.ai.f1': 'تطوير نماذج الذكاء الاصطناعي والتعلم الآلي المخصصة',
  'srvPage.ai.f2': 'روبوتات الدردشة والمساعدين الذكيين',
  'srvPage.ai.f3': 'تحليل البيانات والتصور',
  'srvPage.ai.f4': 'أتمتة العمليات (RPA)',
  'srvPage.ai.f5': 'حلول رؤية الحاسوب',
  'srvPage.ai.f6': 'تكامل إنترنت الأشياء والأنظمة الذكية',

  'srvPage.marketing.longDesc': 'التسويق بدون بيانات مجرد تخمين. نجمع الإبداع مع التحليلات لبناء حملات تعمل فعلاً — تجلب زيارات مؤهلة وتحول العملاء المحتملين وتُوسّع النطاق.',
  'srvPage.marketing.f1': 'تهيئة محركات البحث والتسويق عبرها',
  'srvPage.marketing.f2': 'إدارة وسائل التواصل الاجتماعي',
  'srvPage.marketing.f3': 'الإعلانات المدفوعة (Google، Meta)',
  'srvPage.marketing.f4': 'استراتيجية تسويق المحتوى',
  'srvPage.marketing.f5': 'حملات البريد الإلكتروني والأتمتة',
  'srvPage.marketing.f6': 'نموذج التسويق بتقاسم الأرباح',

  'srvPage.consulting.longDesc': 'التكنولوجيا وحدها ليست استراتيجية. يراجع فريق الاستشارات لدينا وضعك الحالي ويحدد الثغرات ويبني خارطة طريق واضحة نحو النضج الرقمي — ثم يساعدك على تنفيذها.',
  'srvPage.consulting.f1': 'تدقيق وتقييم التكنولوجيا',
  'srvPage.consulting.f2': 'خارطة طريق التحول الرقمي',
  'srvPage.consulting.f3': 'استراتيجية الانتقال إلى السحابة',
  'srvPage.consulting.f4': 'استشارات الأمن السيبراني',
  'srvPage.consulting.f5': 'تدريب الفريق وتطوير المهارات',
  'srvPage.consulting.f6': 'اختيار الموردين والمنصات',

  // SEO Meta Descriptions (150-160 chars)
  'seo.homeDesc': 'الكود المميز – وكالة رقمية رائدة في السعودية. نبني مواقع وتطبيقات وحلول ذكاء اصطناعي تحقق نمواً حقيقياً. أكثر من 500 عميل في 50+ دولة. ابدأ مشروعك اليوم!',
  'seo.aboutDesc': 'تعرف على الكود المميز – وكالة التقنية الرائدة في الرياض. 9+ سنوات في تحويل الأعمال بالويب والجوال والذكاء الاصطناعي. 500+ مشروع، 98% رضا العملاء.',
  'seo.servicesDesc': 'تطوير مواقع وتطبيقات جوال وحلول ذكاء اصطناعي وتسويق رقمي في السعودية. خدمات تقنية متكاملة من الكود المميز. احصل على استشارة مجانية اليوم!',
  'seo.contactDesc': 'تواصل مع الكود المميز في الرياض، المملكة العربية السعودية. فريقنا جاهز لمشاريع الويب والجوال والذكاء الاصطناعي. نرد خلال 24 ساعة. راسلنا أو اتصل بنا الآن.',
  'seo.joinDesc': 'انضم للكود المميز – أسرع وكالة تقنية نمواً في السعودية. وظائف في تطوير الويب والجوال والذكاء الاصطناعي والتصميم والتسويق. عمل عن بعد وهجين. قدّم الآن!',
  'seo.revenueDesc': 'نموذج تقاسم الأرباح من الكود المميز: لا تكلفة مسبقة، نستثمر في نموك ونكسب عندما تكسب. 120+ شريك، نمو متوسط 3.8x. احجز مكالمة استراتيجية مجانية اليوم.',
  'seo.privacyDesc': 'سياسة خصوصية الكود المميز توضح كيف نجمع بياناتك ونستخدمها ونحميها. نلتزم بالشفافية الكاملة ومعايير حماية البيانات المتوافقة مع اللوائح الدولية.',
  'seo.termsDesc': 'اقرأ شروط استخدام الكود المميز قبل استخدام خدماتنا الرقمية. شروط واضحة وعادلة تغطي الملكية الفكرية والمدفوعات والسرية وتسوية النزاعات في السعودية.',
  'seo.partnershipDesc': 'تقدم لبرنامج الشراكة الاستراتيجية من الكود المميز. نموذج تقاسم أرباح بدون مخاطرة مسبقة. ننمو معاً – أكمل النموذج وسنتواصل معك خلال 48 ساعة.',

  // SEO Titles
  'seo.homeTitle': 'الكود المميز | حلول ويب وجوال وذكاء اصطناعي – السعودية',
  'seo.aboutTitle': 'من نحن | الكود المميز – وكالة رقمية في الرياض',
  'seo.servicesTitle': 'خدمات الويب والجوال والذكاء الاصطناعي | الكود المميز',
  'seo.contactTitle': 'تواصل مع الكود المميز | وكالة رقمية – الرياض',
  'seo.joinTitle': 'وظائف تقنية | الكود المميز – فرص العمل في السعودية',
  'seo.revenueTitle': 'نموذج تقاسم الأرباح | الكود المميز – ننمو معاً',
  'seo.privacyTitle': 'سياسة الخصوصية | الكود المميز – حماية البيانات',
  'seo.termsTitle': 'شروط الاستخدام | الكود المميز – خدمات رقمية',
  'seo.partnershipTitle': 'طلب الشراكة الاستراتيجية | الكود المميز',

  // Admin
  'admin.title': 'لوحة التحكم',
  'admin.subtitle': 'إدارة محتوى الموقع بالكامل',
  'admin.logout': 'تسجيل الخروج',
  'admin.loginTitle': 'لوحة الإدارة',
  'admin.loginSubtitle': 'أدخل كلمة المرور للوصول إلى لوحة التحكم',
  'admin.passwordLabel': 'كلمة المرور',
  'admin.loginBtn': 'دخول',
  'admin.loginError': 'كلمة المرور خاطئة. حاول مرة أخرى.',
  'admin.saveBtn': 'حفظ التغييرات',
  'admin.resetBtn': 'إعادة التعيين',
  'admin.savedMsg': 'تم حفظ التغييرات بنجاح!',
  'admin.langEn': 'الإنجليزية',
  'admin.langAr': 'العربية',
  'admin.searchPlaceholder': 'ابحث في الحقول...',
  'admin.unsaved': 'تغييرات غير محفوظة',
  'admin.confirmReset': 'هل أنت متأكد؟ سيتم إعادة تعيين جميع حقول هذا القسم إلى الافتراضي.',
};

export default ar;
